import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'
import { ImportTariffModel } from '../../../core/models/tariff.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { emailValidator } from '../../../shared/utils/email_validator'
import {
  CleanFileName,
  downloadBase64File,
} from '../../../shared/utils/download_base64'
import { MatDivider } from '@angular/material/divider'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatListModule } from '@angular/material/list'

@Component({
  selector: 'modal-download-proposal',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDivider,
    MatProgressBar,
    MatListModule,
  ],
  templateUrl: './modal-download-proposal.component.html',
  styleUrl: './modal-download-proposal.component.scss',
  providers: [ProposalClientService],
  standalone: true,
})
export class ModalDownloadProposalComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private proposalClientService: ProposalClientService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModalDownloadProposalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data.id) {
      this.idProposal = data.id
    }
    if (data.item) {
      this.item = data.item
    }
  }

  item: any = {}
  idProposal: number = -1
  loading: boolean = false

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  downloadPdf() {
    this.loading = true
    this.proposalClientService
      .downloadProposalClientPdf(this.idProposal)
      .subscribe({
        next: (response: any) => {
          // let docName = `${this.item.codigoTg} - ${this.item.nomeCliente} - ${this.item.nomeSubCliente ? this.item.nomeSubCliente + ' - ' : ''} ${this.item.solicitante}`
          // docName = CleanFileName(docName)
          let docName = `${this.item.codigoTg} - ${CleanFileName(this.item.nomeCliente)} - ${this.item.nomeSubCliente ? CleanFileName(this.item.nomeSubCliente) + ' - ' : ''} ${CleanFileName(this.item.solicitante)}`
          downloadBase64File(
            response.data.fileContent,
            docName,
            response.data.type,
          )
          this.snackbar.success(response.message)
          this.close()
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.snackbar.errorRequest(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  downloadExcel() {
    this.loading = true
    this.proposalClientService
      .downloadProposalClientExcel(this.idProposal)
      .subscribe({
        next: (response: any) => {
          // let docName = `${this.item.codigoTg} - ${this.item.nomeCliente} - ${this.item.nomeSubCliente ? this.item.nomeSubCliente + ' - ' : ''} ${this.item.solicitante}`
          // docName = CleanFileName(docName)
          let docName = `${this.item.codigoTg} - ${CleanFileName(this.item.nomeCliente)} - ${this.item.nomeSubCliente ? CleanFileName(this.item.nomeSubCliente) + ' - ' : ''} ${CleanFileName(this.item.solicitante)}`
          downloadBase64File(
            response.data.fileContent,
            docName,
            response.data.type,
          )
          this.snackbar.success(response.message)
          this.close()
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.snackbar.errorRequest(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }
}
